import { Injectable } from '@angular/core';
import { config } from '@app/cuss/embross/utils/config';
import { getDataOperation, xml2json, getKeyByValue } from '@app/cuss/embross/utils/helper';
import { DeviceManager, DeviceStatus, deviceIds, TraceLevels, AppManager } from '../../embross-device-manager'
import OosManager from '@app/cuss/embross/devices/osManager';
import { Observable, Subject, BehaviorSubject } from "rxjs";

let devMgr: any = new DeviceManager('127.0.0.1', 8800, false);
(window as any).devMgr = devMgr

let ossManager: OosManager;
@Injectable({
  providedIn: 'root'
})
export class CussService {
  //devMgr: DeviceManager = new DeviceManager('127.0.0.1', 8800, false);
  transferInfo = null;
  KioskID$ = new BehaviorSubject<string>(null);
  _KioskID = null;
  specialCountryCodeMapping = {
    "D": "DEU"
  };

  oosMgr: any = {};
  errorsTypes = ['DECLINED', 'FAILURE', 'CANCEL'];
  statusOnDevices = new DeviceStatus();
  seatMap = null;
  // devMgr = new DeviceManager('127.0.0.1', 8800, false);

  // devMgr:any = (window as any).devMgr;
  $parsedbardCode: Subject<any> = new Subject<any>();

  constructor() {
    devMgr.setAppManager(this.appMgrOnChange, this.appMgrOnActive, this.appMgrOnEvent);
    // add passport to device manager

    devMgr.addDevices(deviceIds.PASSPORT_READER, this.readerOnEvent, this.isDeviceRequired(deviceIds.PASSPORT_READER));

    // setup barcodeReader
    devMgr.addDevices(deviceIds.BARCODE_READER, this.readerOnEvent, this.isDeviceRequired(deviceIds.BARCODE_READER));
    // setup ATBPrinter

    devMgr.addDevices(deviceIds.ATB_PRINTER, this.readerOnEvent, this.isDeviceRequired(deviceIds.ATB_PRINTER));
    // // setup BagtagPrinter


    devMgr.addDevices(deviceIds.BAGTAG_PRINTER, this.readerOnEvent, this.isDeviceRequired(deviceIds.BAGTAG_PRINTER));

    devMgr.addDevices(deviceIds.BAGGAGE_SCALE, this.readerOnEvent, this.isDeviceRequired(deviceIds.BAGGAGE_SCALE));

    devMgr.addDevices(deviceIds.PAYMENT, this.readerOnEvent, this.isDeviceRequired(deviceIds.PAYMENT));
    devMgr.onConnected = this.OnConnected;
    devMgr.appManager.onSocketOpened = this.OnSocketOpened;
    devMgr.appManager.onActive = this.onActive;
    devMgr.setMaxTraceLevel(TraceLevels.LOG_EXT_TRACE); // should be overwritten later by value from ETS config

    ossManager = new OosManager(
      devMgr,
      config.platformConfig.checkDeviceInterval,
      config.platformConfig.checkDeviceIntervalActive,
      false
    );
    devMgr.connect();
  }
  connect() {
    // devMgr = new DeviceManager('127.0.0.1', 8800, false);
    // setup application manager
    // devMgr.setAppManager(this.appMgrOnChange, this.appMgrOnActive, this.appMgrOnEvent);
    // add passport to device manager

    //devMgr.addDevices(deviceIds.PASSPORT_READER, this.passportReaderOnEvent, this.isDeviceRequired(deviceIds.PASSPORT_READER));

    // setup barcodeReader
    //devMgr.addDevices(deviceIds.BARCODE_READER,()=>{},this.isDeviceRequired(deviceIds.BARCODE_READER));
    // setup ATBPrinter

    //devMgr.addDevices(deviceIds.ATB_PRINTER, () => {}, this.isDeviceRequired(deviceIds.ATB_PRINTER));
    // // setup BagtagPrinter


    // this.devMgr.addDevices(deviceIds.BAGTAG_PRINTER, () => {}, this.isDeviceRequired(deviceIds.BAGTAG_PRINTER));

    // this.devMgr.addDevices(deviceIds.BAGGAGE_SCALE, () => {}, this.isDeviceRequired(deviceIds.BAGGAGE_SCALE));

    // this.devMgr.addDevices(deviceIds.PAYMENT, () => {}, this.isDeviceRequired(deviceIds.PAYMENT));
    // setup cussAccessibility
    //this.devMgr.addDevices(deviceIds.CUSS_ACCESSIBILITY, accessibilityOnEvent, isDeviceRequired(deviceIds.CUSS_ACCESSIBILITY));
    //devMgr.onConnected = this.OnConnected;
    //devMgr.appManager.onSocketOpened = this.OnSocketOpened;
    // devMgr.appManager.onActive = this.onActive;
    // devMgr.setMaxTraceLevel(TraceLevels.LOG_EXT_TRACE); // should be overwritten later by value from ETS config
  }


  appMgrOnChange = (change) => {
    const { key, value } = change;
    if (key == "kioskId") {
      if (value) {
        this.KioskID$.next(value);
        this.KioskID = value;
      }
    }
  }

  set KioskID(KioskId) {
    this._KioskID = KioskId;
  }

  get KioskID() {
    return this._KioskID
  }

  set NextKisoksId(kisokId) {
    this.KioskID$.next(kisokId);
    this.KioskID = kisokId;
  }

  getKioskInfo(): Observable<string> {
    return this.KioskID$.asObservable();
  }

  OnConnected() {

    if (devMgr) {
      try {
        // this.clouds.showClous()
        const connLog = devMgr.setLogger('appManager', true);
        console.info("[ONCONNECT]", connLog);

        if (connLog) {
          // default log file
          devMgr.sendLogMsg(TraceLevels.LOG_EXT_TRACE, 'DeviceManager opened');
          devMgr.sendLogMsg(TraceLevels.LOG_EXT_TRACE, '***** Application version: ' + this.getVersion());
          devMgr.sendLogMsg(TraceLevels.LOG_EXT_TRACE, '***** Application build date: ' + this.getBuildDate());
        } else {
        }
        // send version
        devMgr.appManager.sendVersion('100', true);
        /** config values from websupport.property **/
        devMgr.appManager.getConfig('KIOSK_TYPE');
        devMgr.appManager.getConfig('SMGR_STATION_IN_ID');
        ossManager.start();
      }
      catch (error) {

        throw error;
      }
    }
  }

  OnSocketOpened = (restarting) => {
    if (this.getDeviceManager()) {
      if (restarting) {
        devMgr.sendLogMsg(TraceLevels.LOG_EXT_TRACE, 'OnSocketOpened - restarting');
      } else {
        devMgr.sendLogMsg(TraceLevels.LOG_EXT_TRACE, 'OnSocketOpened');
      }
    }
  }

  isDeviceRequired(deviceId) {
    let deviceName = getKeyByValue(deviceIds, deviceId);
    let ret = config.requiredDevices.indexOf(deviceName) > -1;
    console.info('isDeviceRequired:: deviceName:' + deviceName + ', value:' + ret);
    return false//ret;
  }

  onActive(evt) {
    devMgr.sendLogMsg(TraceLevels.LOG_TRACE, 'deviceName - main evt: ' + evt.key + ' ' + evt.value);
    if (evt.value) {
      sessionStorage.setItem('appMgrOnActive', 'true');
    }
  }

  appMgrOnActive() {
    // appLog('appMgrOnActive() called ..., going to main screen');
    sessionStorage.setItem('appMgrOnActive', 'true');
  }

  appMgrOnEvent(event) {

    console.warn('appMgrOnEvent() is called from client: ' + event.key + ' ' + event.value);
    console.info('appMgrOnEvent() is called from client: ' + event.key + ', value ' + event.value);
    if (event.key === 'notificationText') {
      console.info(event.value);
      if (event.value.indexOf('TRANSFER_INFO') >= 0) {
        let params = event.value.split('=');

      }
    }
    if (event.key === 'getConfig') {
      console.info('received kiosk type:', event.value);
      let res = event.value.split(',');
      if (res.length === 2 && res[0] === 'KIOSK_TYPE') {
        config.kioskType = res[1];
      }
    }
  }

  onInService() {
    console.info('onInService() is called from client.');
  }

  onOutOfService(reason) {
    console.info('onOutOfService() is called. ' + JSON.stringify(reason));
    /* ReactDOM.render(
      <OutOfService store={store} history={history} locale={config.defaultLanguage} />,
      document.getElementById('root')
    ) */
  }

  isResponseInService(json) {
    devMgr.sendLogMsg(
      TraceLevels.LOG_EXT_TRACE,
      'HB isResponseInService: json.etsResponse.inService: ' + json.etsResponse.inService
    );
    if (!config.etsInfo) {
      config.etsInfo = json.etsResponse.serverDetail;
    }
    return json.etsResponse.inService;
  }

  getDeviceManager(): DeviceManager {
    return devMgr;
  }

  getOOSManager(): OosManager {
    return ossManager;
  }

  getAppManager(): AppManager {
    return devMgr.getAppManager();
  }

  /*global VERSION*/
  getVersion() {
    return devMgr.getVersion();
  }

  isConnect() {
    return this.getDeviceManager()?.isConnected();
  }

  /*global BUILD_DATE*/
  getBuildDate() {
    return '"' + this.getCurrentDateTimeString() + '"';
  }

  getCurrentDateTimeString() {
    let d = new Date();
    let year = d.getFullYear();
    let month = d.getMonth() + 1;
    let day = d.getDate();
    let hour = d.getHours();
    let min = d.getMinutes();
    let second = d.getSeconds();
    let fMonth = month < 10 ? '0' + month : month;
    let fDay = day < 10 ? '0' + day : day + ' ';
    let fHour = hour < 10 ? '0' + hour : hour;
    let fMin = min < 10 ? '0' + min : min;
    let fSec = second < 10 ? '0' + second : second;
    return year + '-' + fMonth + '-' + fDay + '  ' + fHour + ':' + fMin + ':' + fSec;
  }

  //#endregion Payment

  //#region Payment
  Payment = () => {
    const paymentDevice = this.getDeviceManager().getDevice(deviceIds.PAYMENT);
    this.callbackPayment.bind(paymentDevice);

    return {
      enablePay: () => {
        paymentDevice.enable();
      },
      enable: (name, KioskID, PNR, amount) => {
        paymentDevice.OnDeviceEvent = this.callbackPayment;
        paymentDevice.enable();
        this.setAmount(name, KioskID, PNR, amount, paymentDevice);
      },
      setAmount: this.setAmount,
      startTransaction: () => {
        paymentDevice.startTransaction();
      },
      getTransactionResult: () => {
        paymentDevice.getTransactionResult();
      },
      getPaymentState: () => {
        paymentDevice.getPaymentState();
      },
      cancelTransaction: () => {
        paymentDevice.cancelTransaction();
      },
      clearTransactionData: () => {
        paymentDevice.clearTransactionData();
      },
      disable: () => {
        paymentDevice.OnDeviceEvent = null;
        paymentDevice.disable();
      },
      device: paymentDevice
    };
  };

  setAmount(name, KioskID, PNR, amount, paymentDevice) {
    const reference = this.getReference(name, KioskID, PNR);
    amount = 1;
    paymentDevice.set('OPCODE', reference);
    paymentDevice.set('AMOUNT', amount);
  }

  getReference(name, KioskID, PNR) {
    var nameLen = name.length;
    var nameOwner = name && name.length > 0 ? name.substring(0, nameLen > 10 ? 10 : nameLen).toUpperCase() : "";
    var today = new Date();
    var format = today.toISOString();
    var dateReference = format.replace(/[-:T]/g, "");
    var dateSplit = dateReference.split(".");
    const sanitzeKiosko = KioskID.replace(/[-\\/:]/g, '');
    const KioskLen = sanitzeKiosko.length;

    const KioskIDSub = sanitzeKiosko.substring(0, KioskLen > 10 ? 10 : KioskLen);
    return nameOwner + KioskIDSub + PNR + dateSplit[0];
  }

  readerOnEvent(event) {
    if (event.key === 'statusChange' && event.value[0] > 300 && event.value[0] < 310) {
      this.getDeviceManager().getAppManager().sendApplicationLog(100, 'CDS_APPLOG,' + event.value[0] + ',passport reader is disconnected')
      this.getOOSManager().completeTransaction(true)
    }
  }

  callbackPayment(event) {
    switch (event.key) {
      case 'stateChanged':
        switch (event.value) {
          // when device is offline
          case 'STATE_UNAVAILABLE':

            break;
          // when device is initially initializing
          case 'STATE_INITIALIZING':

            break;
          // when the device is expecting user interaction and waiting for the amount to be charged to the customer
          case 'STATE_WAITING':
            break;
          // when the amount has been set by the application
          case 'STATE_READY, STATE_WAITING':
            // callbackLogs = 'Event: startTransaction() is called'
            // this.startTransaction();
            break;
          case 'STATE_WAITING, STATE_PENDING':
            break;
          case 'STATE_PENDING, STATE_READY':
            break;
          // when the transaction has been started by the application and we are awaiting the result of the transaction from the device
          case 'STATE_PENDING':
            break;
          // when the transaction has been approved
          case 'STATE_SUCCESS':
          case 'STATE_FAILURE, STATE_PENDING':
          case 'STATE_FAILURE':
          case 'STATE_SUCCESS, STATE_PENDING':
            break;
          default:
        }
        break;
      case 'getTransactionResult':
        const xmlResponse = event.value;
        let response = {
          success: true,
          approved: null,
          message: null
        };
        const { SALE } = getDataOperation(xmlResponse);

        const xmlNode = new DOMParser().parseFromString(xmlResponse, 'text/xml');
        const dataRead = JSON.parse(xml2json(xmlNode));
        const { PaymentResponse } = dataRead;
        if (PaymentResponse && PaymentResponse.PaymentResult) {
          response.success = this.errorsTypes.indexOf(PaymentResponse.PaymentResult) === -1;
        }

        if (response.success) {
          if (SALE) {
            SALE.TDATE = SALE.TDATE.replace(/[/]/g, "-");
            SALE.THOUR = SALE.THOUR.replace(/[:]/g, "");
            SALE.dateOperation = `${SALE.TDATE} ${SALE.THOUR}`;
            response.approved = SALE;
          }
        }
        else {
          response.message = PaymentResponse.PaymentResult;
        }
        /*if (this.cussGlobal.getDataResult(event, response.success, response) !== undefined) {
          this.cussGlobal.getDataResult(event, response.success, response);
        }*/
        break;
      case 'keyPressed':
        break;
      case 'messageChanged':
        break;
      case 'statusChange':
        if (event.value[0] > 300 && event.value[0] < 310) {
          this.getOOSManager().completeTransaction(true);
        }
        break;
      default:
    }
  }

  //#region Scale
  CarryOn = () => {
    const carryon = this.getDeviceManager().getDevice(deviceIds.CARRY_ON);
    return {
      enable: () => {
        carryon.enable();
      },
      disable: () => {
        carryon.disable();
      },
      device: carryon
    };
  };

  callbackSacale(event) {
    switch (event.key) {
      case 'statusResponse':
        break;
      case 'baggagePresent':
        break;
      case 'baggageReadInternal':
      case 'baggageAbsent':
        const response = event.value;
        const xmlNode = new DOMParser().parseFromString(response, 'text/xml');
        const dataRead = JSON.parse(xml2json(xmlNode));
        let weight = 0;
        if (event.key === 'baggageReadInternal' && (dataRead.baggageData && dataRead.baggageData.dimension)) {
          weight = dataRead.baggageData.dimension.load.weight / 1000;
          weight = Math.floor(weight);
        }
        /*if (this.cussGlobal.baggageReadInternal(weight) !== undefined) {
          this.cussGlobal.baggageReadInternal(weight);
        }*/
        break;
      case 'statusChange':
        if (event.value[0] > 300 && event.value[0] < 310) {
          this.getOOSManager().completeTransaction(true);
        }
        break;
      default:
        break;
    }
  }

}
